export const customerListColumns = [
  {
    title: "公司名称",
    width: 224,
    align: "center",
    ellipsis: true,
    resizable: true,
    // dataIndex: "customerName",
    key: "customerName",
    scopedSlots: { customRender: "customerName" }
  },
  {
    title: "跟进内容",
    width: 280,
    align: "center",
    ellipsis: true,
    resizable: true,
    // scopedSlots: { customRender: "followUpNote" },
    dataIndex: "followUpNote",
    key: "followUpNote"
  },
  {
    title: "跟进时间",
    width: 136,
    sorter: (a, b) => new Date(a.followUpTime) - new Date(b.followUpTime),
    // defaultSortOrder: 'ascend',
    align: "center",
    ellipsis: true,
    resizable: true,
    scopedSlots: { customRender: "followUpTime" },
    key: "followUpTime"
  },
  {
    title: "创建日期",
    width: 136,
    ellipsis: true,
    sorter: (a, b) => new Date(a.insertTime) - new Date(b.insertTime),
    defaultSortOrder: "descend",
    align: "center",
    resizable: true,
    scopedSlots: { customRender: "insertTime" },
    key: "insertTime"
  },
  {
    title: "指派状态",
    width: 80,
    align: "center",
    ellipsis: true,
    resizable: true,
    scopedSlots: { customRender: "assignType" },
    key: "assignType"
  },
  {
    title: "指派员工",
    width: 80,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "displayNameList",
    // scopedSlots: { customRender: "displayNameList" },
    key: "displayNameList"
  },
  {
    title: "项目数",
    width: 56,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "projectNum",
    // scopedSlots: { customRender: "projects" },
    key: "projectNum"
  },
  {
    title: "客户状态",
    width: 88,
    align: "center",
    ellipsis: true,
    resizable: true,
    scopedSlots: { customRender: "tag" },
    key: "tag"
  },
  {
    title: "客户分类",
    width: 88,
    align: "center",
    ellipsis: true,
    resizable: true,
    scopedSlots: { customRender: "customerType" },
    key: "customerType"
  },
  {
    title: "客户区域",
    width: 80,
    align: "center",
    ellipsis: true,
    resizable: true,
    scopedSlots: { customRender: "customerRegionType" },
    key: "customerRegionType"
  },
  {
    title: "国家或地区",
    width: 104,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "country",
    key: "country"
  },
  {
    title: "访问方式",
    width: 72,
    align: "center",
    ellipsis: true,
    resizable: true,
    scopedSlots: { customRender: "accessType" },
    key: "accessType"
  },
  {
    title: "联系人姓名",
    width: 88,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "contactNameList",
    key: "contactNameList"
  },
  {
    title: "联系人电话",
    width: 112,
    align: "center",
    resizable: true,
    dataIndex: "contactTelList",
    key: "contactTelList"
  },
  {
    title: "搜索关键字",
    width: 88,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "keywordValue",
    key: "keywordValue"
  },
  {
    title: "来源平台",
    width: 72,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "platformNameValue",
    key: "platformNameValue"
  },
  {
    title: "市",
    width: 64,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "city",
    key: "city"
  },
  {
    title: "省",
    width: 64,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "province",
    key: "province"
  },
  {
    title: "创建者",
    width: 80,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "creatorDisplayName",
    key: "creatorDisplayName"
  },
  {
    title: "近期修改日期",
    width: 136,
    ellipsis: true,
    resizable: true,
    align: "center",
    scopedSlots: { customRender: "updateTime" },
    key: "updateTime"
  },
  {
    title: "操作",
    width: 176,
    fixed: "right",
    align: "center",
    className: "erp-table-operation-col",
    key: "operation",
    scopedSlots: { customRender: "operation" }
  }
]

export const contactColumns = [
  {
    title: "联系人",
    width: 140,
    align: "center",
    ellipsis: true,
    resizable: true,
    scopedSlots: { customRender: "contactName" },
    key: "contactName"
  },
  {
    title: "联系方式",
    width: 160,
    align: "center",
    ellipsis: true,
    resizable: true,
    scopedSlots: { customRender: "contactTel" },
    key: "contactTel"
  },
  {
    title: "联系人类型",
    width: 120,
    align: "center",
    ellipsis: true,
    resizable: true,
    scopedSlots: { customRender: "contactType" },
    key: "contactType"
  },
  {
    title: "操作",
    width: 72,
    align: "center",
    className: "erp-table-operation-col",
    key: "operation",
    scopedSlots: { customRender: "operation" }
  }
]
